<template>
  <v-app>
    <v-main
      :class="$route.name == `auth.login` ? `d-flex align-center justify-center` : ``"
    >
      <router-view />
    </v-main>
  </v-app>
</template>
<script>
import { useTheme } from "vuetify";
import { onBeforeMount } from "vue";
import _ from "lodash";
import { useRouter, useRoute } from "vue-router";
import axios from "axios";
import store from "../store";
import { useStore } from "vuex";
export default {
  name: "App",
  setup(props, { ctx }) {
    const theme = useTheme();
    const route = useRoute();
    const router = useRouter();
    const store = useStore();
    const logout = () => store.dispatch("auth/logout");
    store.dispatch("auth/load");

    axios.interceptors.response.use(
      function (response) {
        return response;
      },
      async function (error) {
        if (_.get(error, "response.status", null) === 401 && route.name != "auth.login") {
          router.push({ name: "auth.login" });
          return Promise.reject(error);
        }
        return Promise.reject(error);
      }
    );
    onBeforeMount(() => {
      theme.global.name.value =
        localStorage.getItem("theme") === "dark" ? "dark" : "light";
    });
    return {
      logout,
    };
  },
};
</script>
